/** 画面表示項目 */
export interface ScreenDisplayItems {
  title: Title
  interviewSchedule: InterviewSchedule
  messageInput: MessageInput  
  sendTargetConfirmation: SendTargetConfirmation
  sendTimeInput: SendTimeInput
  recruitmentManagementFlag: RecruitmentManagementFlag[]
  seminarSchedule: SeminarSchedule[]
  seminar: Seminar[]
  signature: Signature[]
}

/** タイトルエリア */
export interface Title {
  [key: string]: any
  messageTemplate: MessageTemplate[]
}

export interface MessageTemplate {
  [key: string]: any
  messageTemplateSettingId: number
  templateName: string
  templateType: string
  destinationDivision: string
  senderCompanyName: string
  senderMailAddress: string
  replayPermitFlag: string
  subject: string
  body: string
  reservedScheduleSendFlag: string
  barcordDisplayFlag: string
  sequence: number
  sysVersionNumber: string
}

/** 送信対象確認エリア */
export interface SendTargetConfirmation {
  [key: string]: any
  destinationSelection: string
  sendTarget: SendTarget[]
  searchCriteriaName: string
  searchCriteria: string
  searchCriteriaInfo: SearchCriteriaInfo
  mySearchCondition: string| null
  conversionMySearch: MySearch[]
  filterCondition: string
}

export interface SearchCriteriaInfo {
  entrySearchCriteriaSettingId: string // エントリー検索条件設定ID
  searchCriteriaName: string           // 検索条件名
  searchCriteria: string               // 検索条件
  sysVersionNumber: number             // sysバージョン番号
}

export interface MySearch {
  mySearchName: string //MY検索条件名
  mySearchCriteria: string //MY検索条件
}

/** 送信対象 */
export interface SendTarget {
  [key: string]: any
  entryId: string
  selectionManagementId: string
  progressStatusSettingId: string
  decisionDivision: string
  manualRegistrationFlag: string
  fullName: string
  mailAddress: string
  age: number
  jobSeekerId: string
  mynaviMemberInfo: string
  applicationType: string
  entryType: string
  jobTitle: string
  schoolName: string
  facultyName: string
  subjectName: string
  applicationDate: string
  progress: string
  selectionFlow: string
  selectionClassification: string
  invisibleDestination: string
  deleteDestination: string
  notSend: boolean
  applicantScreeningImmunityFlag: string
}

/** 面接日程調整エリア */
export interface InterviewSchedule {
  [key: string]: any
  manipulationSelection: number
  manipulationKubun: string
  interviewDetail: string
  requiredTimeId: string
  interviewDurationSelect: InterviewDurationSelect[]
  interviewLocation: InterviewLocation[]
  candidateDate: CandidateDate[]
}

export interface InterviewDurationSelect {
  [key: string]: any
  interviewDurationId: string
  actualTime: string
  displayTime: string
}

export interface InterviewLocation {
  [key: string]: any
  id: number
  name: string
  address: string
  mapUrl: string
  type: string
  deleteFlag: boolean
}

export interface CandidateDate {
  [key: string]: any
  interviewStartTime: string
  interviewLocationId: string
  interviewStaffName: string
}

/** メッセージ入力エリア */
export interface MessageInput {
  [key: string]: any
  headingMessageInput: string
  headingMessageInputDescription: string
  exampleLink: string
  replyAllow: string
  repliesNecessary: string
  repliesLimit: string|null
  senderCompanyName: string
  senderMailAddress: string
  subject: string
  body: string
  targetInput: string
  attachment: Attachment[]
  entryBox: MynaviAttachedOptionEntryBox[]
  seminar: MynaviAttachedOptionSeminar[]
  entryBoxId: string[]
  seminarId: string[]
  homePage: HomePage[]
  barcodeDisplay: string
  previewSubject: string
  previewBody: string
}

/** 送信日時入力エリア */
export interface SendTimeInput {
  [key: string]: any
  transmission: string
  sendPlanTime: Date | null
}

export interface MynaviAttachedOptionEntryBox {
  entryBoxId: number
  mynaviAttachedOptionName: string
  contractMediaName: string
  displayStartDate: Date
  displayEndDate: Date
  previewUrl: string
}

export interface MynaviAttachedOptionSeminar {
  seminarId: number
  mynaviAttachedOptionName: string
  contractMediaName: string
  displayStartDate: Date
  displayEndDate: Date
  previewUrl: string
}

export interface Attachment {
  attachmentFileName: string
  attachmentId: string|null
  attachmentName: string
}

export interface HomePage {
  homePageTitle: string
  homePageUrl: string
}

export interface RecruitmentManagementFlag {
  [key: string]: any
  recruitmentManagementFlagSettingId: number
  recruitmentManagementFlagName: string
}

export interface SeminarSchedule {
  [key: string]: any
  seminarScheduleId: number
  eventDate: Date
  venueLocationName: string
  startTime: Date
  endTime: Date
  coordinationFormerSeminarScheduleIdentificationKey: string
  invisibleFlag: string
  contractMediaName: string
}

export interface Seminar {
  [key: string]: any
  seminarId: number
  coordinationFormerSeminarId: number
  seminarName: string
  publicFlag: string
  contractMediaName: string
}

export interface Signature {
  [key: string]: any
  registrationName: string
  signSettingId: string
  signature: string
}

export interface RegisterValue {
  [key: string]: any
  messageType: string[]
  messageTemplateSettingId: string|null
  destinationId: string[]
  selectionManagementId: string[]
  destination: number
  // [phase2] start by zhangxp
  sendToNonMember: number
  // [phase2] end by zhangxp
  senderCompanyName: string
  senderMailAddress: string
  allowReply: number
  subject: string
  body: string
  attachment: any[]
  attachmentId: string[]
  templateAttachmentId: string[]
  templateAttachmentName: string[]
  mynaviAttachedOption: string
  homePageTitle1: string|null
  homePageTitle2: string|null
  homePageTitle3: string|null
  homePageUrl1: string|null
  homePageUrl2: string|null
  homePageUrl3: string|null
  barcodeDisplayFlag: number
  sendTimer: number
  sendPlanTime: string|null
  notifyNotification: number
  notifyMailAddress: string
  requiredTimeId: string
  interviewContents: string
  interviewDateN: (string|null)[]
  interviewLocationIdN: (number|null)[]
  chargeN: string[]
  fileManagementId: string[]
  fileManagementName: string[]
  entryId: number[]
  interviewScheduleAdjustmentId: number
  //adjustmentInterviewScheduleId: number[]
  sysVersionNumber: string
  messageSendId: string
  interviewScheduleAdjustmentStatus: string
  interviewScheduleAdjustmentSelection: string
  adjustmentInterviewScheduleAdjustmentId: string
  interviewDurationId: string|null
  interviewDetail: string
  interviewScheduleId: number[]
  interviewStartTime: (string|null)[]
  interviewStaffName: string[]
  interviewScheduleStatus: string[]
  adjustmentInterviewDurationId: string|null
  adjustmentInterviewDetail: string
  adjustmentInterviewScheduleId: number[]
  adjustmentInterviewStartTime: (string|null)[]
  adjustmentInterviewStaffName: string[]
  adjustmentInterviewScheduleStatus: string[]
  newInterviewScheduleStatus: string[]
  adjustmentInterviewLocationId: (number|null)[]
  manipulationKubun: string
  seminarId: number[]
  entryBoxId: number[]
  sendTimeFlag: string
  replyPermitFlag: string
  replyNecessaryFlag: string
  replyLimitTime: string|null
  destinationDivision: string
  manualRegistrationFlag: string[]
  memberType: string[]
  decisionDivision: string[]
  progressStatusSettingId: number[]
  notSend: boolean[]
  notificationMailAddress: string
  replyFromMessageSendId: string
  title: Title
  interviewSchedule: InterviewSchedule
  messageInput: MessageInput  
  sendTargetConfirmation: SendTargetConfirmation
  sendTimeInput: SendTimeInput
  recruitmentManagementFlag: RecruitmentManagementFlag[]
  seminarSchedule: SeminarSchedule[]
  seminar: Seminar[]
  signature: Signature[]
  fullName: string
  draftMessageSendId: number
  messageSendIds: number[]
  interviewScheduleAdjustmentMax: MCAZS080InterviewScheduleAdjustmentMaxResultDto[]
  searchCriteriaName: string
  searchCriteria: string
  searchCriteriaJson: string,
  mySearchCondition: string|null,
  mySearchCriteriaNameJson: string[],
  mySearchCriteriaJson: string[],
  selectionManagementSysVersionNumber: number|null
  progressManagementSysVersionNumber: number|null
  notAdoptedNotificationType: string|null
  interviewScheduleIdWeb: number,
  interviewWebEnableFlag: string,
  interviewWebUrlSendFlag: string,
  sysVersionNumberWeb: string,
  senderMessageId:(number|null)[],
}

export interface MCAZS080InterviewScheduleAdjustmentMaxResultDto {
  [key: string]: any
  interviewScheduleAdjustmentId: number
  selectionManagementId: number
}

const title: Title = {
  messageTemplate: [],
}

const interviewSchedule: InterviewSchedule = {
  manipulationKubun: '',
  manipulationSelection: 0,
  interviewDetail: '',
  requiredTimeId: '',
  interviewDurationSelect: [],
  interviewLocation: [],
  candidateDate: [],
}

const interviewDurationSelect: InterviewDurationSelect = {
  interviewDurationId: '',
  actualTime: '',
  displayTime: '',
}

const interviewLocation: InterviewLocation = {
  id: 0,
  name: '',
  address: '',
  mapUrl: '',
  type: '',
  deleteFlag: false,
}

const messageInput: MessageInput = {
  headingMessageInput: '',
  headingMessageInputDescription: '',
  exampleLink: '',
  replyAllow: '0',
  repliesNecessary: '0',
  repliesLimit: null,
  // [phase2] start by zhangxp
  sendToNonMember: 0,
  // [phase2] end by zhangxp
  senderCompanyName: '',
  senderMailAddress: '',
  subject: '',
  body: '',
  targetInput: '',
  attachment: [],
  templateAttachmentId: [],
  entryBox: [],
  seminar: [],
  entryBoxId: [],
  seminarId: [],
  homePage: [],
  homePageTitle: [],
  homePageUrl: [],
  barcodeDisplay: '0',
  previewSubject: '',
  previewBody: '',
}

const sendTimeInput: SendTimeInput = {
  transmission: '0',
  sendPlanTime: null,
}

const sendTarget: SendTarget = {
  entryId: '',
  selectionManagementId: '',
  progressStatusSettingId: '',
  decisionDivision: '',
  manualRegistrationFlag: '',
  fullName: '',
  mailAddress: '',
  age: 0,
  jobSeekerId: '',
  mynaviMemberInfo: '',
  applicationType: '',
  entryType: '',
  jobTitle: '',
  schoolName: '',
  facultyName: '',
  subjectName: '',
  applicationDate: '',
  progress: '',
  selectionFlow: '',
  selectionClassification: '',
  invisibleDestination: '',
  deleteDestination: '',
  notSend: false,
  applicantScreeningImmunityFlag: '',
}

const searchCriteriaInfo: SearchCriteriaInfo = {
  entrySearchCriteriaSettingId: '',
  searchCriteriaName: '',
  searchCriteria: '',
  sysVersionNumber: 0,
}

const mySearch: MySearch = {
  mySearchName: '',
  mySearchCriteria: '',
}

const sendTargetConfirmation: SendTargetConfirmation = {
  destinationSelection: '0',
  sendTarget: [],
  searchCriteriaName: '',
  searchCriteria: '',
  searchCriteriaInfo: searchCriteriaInfo,
  mySearchCondition: null,
  conversionMySearch: [],
  filterCondition: '',
}

const recruitmentManagementFlag: RecruitmentManagementFlag[] = []

const seminarSchedule: SeminarSchedule[] = []

const seminar: Seminar[] = []

const signature: Signature[] = []

const registerValue: RegisterValue = {
  messageType: [],
  messageTemplateSettingId: '',
  destinationId: [],
  selectionManagementId: [],
  destination: 0,
  // [phase2] start by zhangxp
  sendToNonMember: 0,
  // [phase2] end by zhangxp
  senderCompanyName: '',
  senderMailAddress: '',
  allowReply: 0,
  subject: '',
  body: '',
  attachment: [],
  attachmentId: [],
  templateAttachmentId: [],
  templateAttachmentName: [],
  mynaviAttachedOption: '',
  homePageTitle1: null,
  homePageTitle2: null,
  homePageTitle3: null,
  homePageUrl1: null,
  homePageUrl2: null,
  homePageUrl3: null,
  barcodeDisplayFlag: 0,
  sendTimer: 0,
  sendPlanTime: null,
  notifyNotification: 0,
  notifyMailAddress: '',
  requiredTimeId: '',
  interviewContents: '',
  interviewDateN: [],
  interviewLocationIdN: [],
  chargeN: [],
  fileManagementId: [],
  fileManagementName: [],
  entryId: [],
  interviewScheduleAdjustmentId: 0,
  sysVersionNumber: '',
  messageSendId: '',
  interviewScheduleAdjustmentStatus: '',
  interviewScheduleAdjustmentSelection: '',
  adjustmentInterviewScheduleAdjustmentId: '',
  interviewDurationId: null,
  interviewDetail: '',
  interviewScheduleId: [],
  interviewStartTime: [],
  interviewStaffName: [],
  interviewScheduleStatus: [],
  adjustmentInterviewDurationId: null,
  adjustmentInterviewDetail: '',
  adjustmentInterviewScheduleId: [],
  adjustmentInterviewStartTime: [],
  adjustmentInterviewStaffName: [],
  adjustmentInterviewScheduleStatus: [],
  newInterviewScheduleStatus: [],
  adjustmentInterviewLocationId: [],
  manipulationKubun: '',
  seminarId: [],
  entryBoxId: [],
  sendTimeFlag: '',
  replyPermitFlag: '',
  replyNecessaryFlag: '',
  replyLimitTime: '',
  destinationDivision: '',
  manualRegistrationFlag: [],
  memberType: [],
  decisionDivision: [],
  progressStatusSettingId: [],
  notSend: [],
  notificationMailAddress: '',
  replyFromMessageSendId: '',
  title: title,
  interviewSchedule:interviewSchedule,
  messageInput: messageInput,
  sendTargetConfirmation: sendTargetConfirmation,
  sendTimeInput: sendTimeInput,
  recruitmentManagementFlag: recruitmentManagementFlag,
  seminarSchedule: seminarSchedule,
  seminar: seminar,
  signature: signature,
  fullName : '',
  draftMessageSendId: 0,
  messageSendIds: [],
  interviewScheduleAdjustmentMax: [],
  searchCriteriaName: '',
  searchCriteria: '',
  searchCriteriaJson: '',
  mySearchCondition: null,
  mySearchCriteriaNameJson: [],
  mySearchCriteriaJson: [],
  selectionManagementSysVersionNumber: null,
  progressManagementSysVersionNumber: null,
  notAdoptedNotificationType: null,
  interviewScheduleIdWeb: 0,
  interviewWebEnableFlag: '',
  interviewWebUrlSendFlag: '',
  sysVersionNumberWeb: '',
  senderMessageId: [],
}

/** MCAZS101呼び出し用 */
export interface MCAZS091JobSeekerSelectionInfoDto {
  progressStatusSettingId: number[]
  selectionFlowSettingId: number
  
}

export interface MessageConfVal {
  messageTemplateSettingId: string|null
  entryId: number[]
  selectionManagementId: string[]
  progressStatusSettingId: number[]
  selectionFlowSettingId: number[]
  sendTimeFlag: string
  successfulCountMessage: number
  successfulCountEmail: number
  failedCount: number
  messageTemplateSttingId: string|null
  templateName: string
  notAdoptedNotificationType: string|null
}

const mCAZS091JobSeekerSelectionInfoDto: MCAZS091JobSeekerSelectionInfoDto = {
  progressStatusSettingId: [],
  selectionFlowSettingId: 0,
}

const messageConfVal: MessageConfVal = {
  messageTemplateSettingId: "",
  entryId: [],
  selectionManagementId: [],
  progressStatusSettingId: [],
  selectionFlowSettingId: [],
  sendTimeFlag: "",
  successfulCountMessage: 0,
  successfulCountEmail: 0,
  failedCount: 0,
  messageTemplateSttingId: "",
  templateName: "",
  notAdoptedNotificationType: null,
}


export {
  title,
  interviewSchedule,
  interviewDurationSelect,
  messageInput,
  sendTimeInput,
  sendTarget,
  sendTargetConfirmation,
  recruitmentManagementFlag,
  registerValue,
  seminarSchedule,
  seminar,
  signature,
  mCAZS091JobSeekerSelectionInfoDto,
  messageConfVal,
}

